__turbopack_context__.v({
  "avatar-container": "PostInfo-module-scss-module__Nyc-Jq__avatar-container",
  "no-avatar": "PostInfo-module-scss-module__Nyc-Jq__no-avatar",
  "post-author": "PostInfo-module-scss-module__Nyc-Jq__post-author",
  "post-info": "PostInfo-module-scss-module__Nyc-Jq__post-info",
  "read-length": "PostInfo-module-scss-module__Nyc-Jq__read-length",
});
